import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Box, Flex, VStack, Link, Button, Heading, Spacer } from "@chakra-ui/react";
import { useAuth } from "../../context/AuthContext";

const SuperAdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkProps = {
    px: 3,
    py: 2,
    borderRadius: "md",
    color: "white",
    _hover: { bg: "gray.700" },
    _activeLink: { fontWeight: "bold", bg: "gray.700" },
    display: "flex",
    alignItems: "center",
    gap: 3,
  };

  return (
    <Flex h="100vh" w="100vw" bg="gray.50">
      <Box as="aside" w="240px" bg="gray.900" color="white" p={4}>
        {/* <Heading size="md" mb={4}>Super Admin</Heading> */}
        <VStack align="stretch" spacing={1}>
          <Link as={NavLink} to="/admin" end {...linkProps}>Statistics</Link>
          <Link as={NavLink} to="/admin/configuration" {...linkProps}>Configuration</Link>
          {/* <Link as={NavLink} to="/admin/users" {...linkProps}>Users</Link>
          <Link as={NavLink} to="/admin/templates" {...linkProps}>Templates</Link> */}
        </VStack>
      </Box>
      <Flex direction="column" flex="1" minW={0}>
        <Flex as="header" h="60px" align="center" px={6} bg="white" borderBottomWidth="1px">
          <Heading size="sm">ASAP Admin Console</Heading>
          <Spacer />
          <Button size="sm" onClick={doLogout}>Logout</Button>
        </Flex>
        <Box as="main" p={6} overflowY="auto" flex="1">
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
};

export default SuperAdminLayout;


